import React from "react";

export const PrimaryBtn = ({ children, className = "", ...p }) => (
  <button {...p}
    className={`bg-[#CCFF00] text-[#0A0A0A] font-bold uppercase tracking-wide px-6 py-3 text-sm transition-colors hover:bg-[#dcff40] active:translate-y-px disabled:opacity-40 disabled:cursor-not-allowed ${className}`}>
    {children}
  </button>
);

export const GhostBtn = ({ children, className = "", ...p }) => (
  <button {...p}
    className={`border border-[#262626] text-white font-bold uppercase tracking-wide px-6 py-3 text-sm transition-colors hover:border-[#CCFF00] hover:text-[#CCFF00] active:translate-y-px disabled:opacity-40 ${className}`}>
    {children}
  </button>
);

export const Card = ({ children, className = "", ...p }) => (
  <div {...p} className={`border border-[#262626] bg-[#141414] ${className}`}>{children}</div>
);

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="block text-xs font-bold uppercase tracking-[0.15em] text-[#A3A3A3] mb-2">{label}</span>
    {children}
    {hint && <span className="block text-xs text-[#666] mt-1">{hint}</span>}
  </label>
);

const inputCls =
  "w-full bg-[#0A0A0A] border border-[#262626] text-white px-4 py-3 text-sm outline-none focus:border-[#CCFF00] focus:ring-1 focus:ring-[#CCFF00] transition-colors placeholder:text-[#555]";

export const Input = (p) => <input {...p} className={`${inputCls} ${p.className || ""}`} />;
export const Select = ({ children, ...p }) => (
  <select {...p} className={`${inputCls} ${p.className || ""}`}>{children}</select>
);
export const Textarea = (p) => <textarea {...p} className={`${inputCls} ${p.className || ""}`} />;

export const Loading = ({ text = "LOADING…" }) => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="font-heading text-2xl text-[#CCFF00] animate-pulse">{text}</div>
  </div>
);

export const PageHeader = ({ eyebrow, title, right }) => (
  <div className="flex items-end justify-between gap-4 mb-8">
    <div>
      {eyebrow && <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#CCFF00] mb-2">{eyebrow}</div>}
      <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl uppercase leading-none">{title}</h1>
    </div>
    {right}
  </div>
);

export const levelColor = (lvl) =>
  lvl === "HIGH" ? "text-[#FF3B30] border-[#FF3B30]"
  : lvl === "MEDIUM" ? "text-[#CCFF00] border-[#CCFF00]"
  : "text-[#A3A3A3] border-[#262626]";
